export const isEnterOnly = (event) => event && !event.shiftKey && event.keyCode === 13

export const isShiftEnter = (event) => event && event.shiftKey && event.keyCode === 13

export default {
  isEnterOnly,
  isShiftEnter,
}
